import { updateObject } from 'store/utility';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    works: {},
    objects: {},
    complete: {},
    search: {},
    fulltext: {}, 
    doSearch: false,
    limit: {
        work: 20,
        object: 20,
        person: 20
    },
    offset: {
        work: 0,
        object: 0,
        person: 0
    },
    sort: {
        work: { field: "title", dir: "ASC" },
        object: { field: "archive_number", dir: "ASC" }
    },
    count: {
        work: 0,
        object: 0
    },
    section: "work"
}
const sdkSearchSucces = (state, action) => {
    const fulltext = { ...state.fulltext, ...action.fulltext };
    const search = { ...state.search, ...action.search }
    const offset = { ...state.offset }
    offset[action.section] = 0;
    
    return updateObject(state, { search: search, section: action.section, fulltext: fulltext, offset: offset, doSearch: true });
}

const sdkSetLimit = (state, action) => {
    const limit = { ...state.limit }
    limit[action.section] = action.limit;
    const offset = { ...state.offset }
    offset[action.section] = 0;
    return updateObject(state, { limit: limit, offset: offset, doSearch: true });
}

const CutReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SDK_WORK_GET_SUCCESS:
            let works = state.count;
            works["work"] = action.count;
            return updateObject(state, { works: action.works, count: works, doSearch: false });
        case actionTypes.SDK_OBJECT_GET_SUCCESS:
            let objects = state.count;
            objects["object"] = action.count;
            return updateObject(state, { objects: action.objects, count: objects, doSearch: false });
        case actionTypes.SDK_SEARCH_SUCCESS:
            return sdkSearchSucces(state, action);
        case actionTypes.SDK_WORK_GET_ONE_SUCCESS:
            let x = state.complete;
            x[action.id] = action.work;
            return updateObject(state, { complete: x });
        case actionTypes.SDK_SET_LIMIT:
            return sdkSetLimit(state, action);
        case actionTypes.SDK_SET_SORT:
            const sort = { ...state.sort }
            sort[action.section] = action.sort;
            return updateObject(state, { sort: sort, doSearch: true });
        case actionTypes.SDK_SET_OFFSET:
            const offset = { ...state.offset }
            offset[action.section] = action.offset;
            return updateObject(state, { offset: offset, doSearch: true });
        default:
            return state;
    }
}

export default CutReducer;
